export function isObjectNullOrEmpty(obj: any) {
  return !obj || obj && Object.values(obj).every(value => {
    // 👇️ check for multiple conditions
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  });
}
